<template>
  <div id="app">
    <header-index v-if="handshow"></header-index>
    <router-view />
    <footer-index-vue v-if="navShow"></footer-index-vue>
  </div>
</template>

<script>
import HeaderIndex from './components/header/headerIndex.vue'
import footerIndexVue from './components/footer/footerIndex.vue'
import * as sysTool from './assets/unit/GetuserAgent';
export default {
  components: { HeaderIndex, footerIndexVue },
  data () {
    return {
      navShow: true,
      handshow: true
    }
  },
  watch: {
    '$route' (to, from) {
      // 当路由发生变化时执行的代码
      // console.log('当前路由名称：', to.name);
      // console.log('当前路由参数：', to.params);
      // console.log('当前路由查询：', to.query);
      // 在这里处理你的逻辑
      if (to.name == 'login') {
        this.handshow = false
      } else {
        this.handshow = true
      }
      if (to.name == 'login' || to.name == 'collect' || to.name == 'refinedSift') {
        this.navShow = false
      } else {
        this.navShow = true
      }
      // console.log(localStorage.getItem('userInfo'))
      if (localStorage.getItem('useragentinfo')) {
        let useragentinfo = JSON.parse(localStorage.getItem('useragentinfo'))
        this.httphelper.post('/HCUserApi/SaveUserBehavior', {
          userID: localStorage.getItem('userInfo') == null ? 0 : JSON.parse(localStorage.getItem('userInfo')).userId,
          ip: useragentinfo.ip.trim() != '' ? useragentinfo.ip : '未获取',
          area: useragentinfo.area.trim() !== ''
            ? useragentinfo.area
            : (useragentinfo.city.trim() !== ''
                ? useragentinfo.city
                : (useragentinfo.province.trim() !== '' ? useragentinfo.province : '未指定')),
          weburl: window.location.origin + to.fullPath,
          os: sysTool.getOS(),
          browser: sysTool.getBrowser(),
          network: sysTool.getNetworkType()
        });
      }
    }
  }
}
</script>

<style lang="scss">
@import "./assets/css/comm.css";
@import "./assets/css/globe.css";

body,
html {
  padding: 0;
  margin: 0;
}
</style>
